export default __webpack_public_path__ + "static/home-page-header-b3b793287260b04b9dbfa3bc224965d2.png";